document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".popup-main--upsell").forEach(function (popup) {
    const sectionEl = popup.closest('[id^="shopify-section-"]');
    if (!sectionEl) return;

    const overlay = sectionEl.querySelector(".popup-overlay");
    const bundleWrap = popup.querySelector(".protection-bundle");
    if (!bundleWrap) return;

    const protectionVariantId = bundleWrap.getAttribute("data-bundle-variant-id") || "";
    if (!protectionVariantId) return;

    const productHandle =
      bundleWrap.getAttribute("data-product-handle") ||
      popup.getAttribute("data-product-handle") ||
      "";

    const addToCartBtn =
      document.querySelector('.product-form__submit[name="add"]') ||
      document.querySelector('button.product-form__submit[name="add"]') ||
      document.querySelector("button.product-form__submit");
    if (!addToCartBtn) return;

    const productForm = addToCartBtn.closest("form");
    if (!productForm) return;

    const upsellAddBtn = popup.querySelector(".js-upsell-add-bundle");
    const upsellSkipBtn = popup.querySelector(".js-upsell-skip");
    const upsellCloseBtn = popup.querySelector(".popup-close");

    let mainVariantId = null;
    let mainQty = 1;

    const cartUI = document.querySelector("cart-notification") || document.querySelector("cart-drawer");

    function closePopup() {
      popup.classList.remove("is-active");
      if (overlay) overlay.classList.remove("is-active");
    }

    function makeUid(variantId, i) {
      return String(variantId) + "-" + Date.now() + "-" + Math.random().toString(16).slice(2) + "-" + String(i);
    }

    function addItemsToCart(addProtection, pbSource) {
      if (!mainVariantId) return;

      const qty = Math.max(0, parseInt(mainQty, 10) || 0);
      if (qty === 0) {
        closePopup();
        return;
      }

      const items = [];

      for (let i = 0; i < qty; i++) {
        const uid = makeUid(mainVariantId, i);

        items.push({
          id: Number(mainVariantId),
          quantity: 1,
          properties: {
            _bundle_uid: uid
          }
        });

        if (addProtection && protectionVariantId) {
          const bundleProps = {};

          if (uid) {
            bundleProps._bundle_parent_uid = uid;
          }

          if (mainVariantId) {
            bundleProps._bundle_parent_variant_id = String(mainVariantId);
          }

          if (productHandle) {
            bundleProps._bundle_parent_product_handle = productHandle;
          }

          if (pbSource) {
            bundleProps._pb_source = pbSource;
          }

          items.push({
            id: Number(protectionVariantId),
            quantity: 1,
            properties: bundleProps
          });
        }
      }

      const payload = { items: items };

      if (cartUI && typeof cartUI.getSectionsToRender === "function") {
        payload.sections = cartUI.getSectionsToRender().map(function (s) {
          return s.id;
        });
        payload.sections_url = window.location.pathname;
      }

      const root =
        window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root
          : "/";

      fetch(root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify(payload)
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (data) {
          closePopup();
          if (cartUI && typeof cartUI.renderContents === "function") {
            cartUI.classList.remove("is-empty");
            cartUI.renderContents(data);
          } else {
            window.location.href = "/cart";
          }
        })
        .catch(function () {
          closePopup();
          if (!cartUI) window.location.href = "/cart";
        });
    }

    addToCartBtn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();

      const variantInput = productForm.querySelector('input[name="id"]');
      const qtyInput = productForm.querySelector('input[name="quantity"]');

      if (!variantInput) return;

      mainVariantId = variantInput.value;

      const rawQty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      mainQty = Number.isFinite(rawQty) ? rawQty : 1;

      if (mainQty <= 0) {
        closePopup();
        return;
      }

      const selectedVariant =
        (window.ShopifyAnalytics &&
          window.ShopifyAnalytics.meta &&
          window.ShopifyAnalytics.meta.selectedVariant) || null;

      if (selectedVariant && selectedVariant.available === false) {
        addItemsToCart(false, null);
        return;
      }

      popup.classList.add("is-active");
      if (overlay) overlay.classList.add("is-active");
    });

    if (upsellAddBtn) {
      upsellAddBtn.addEventListener("click", function () {
        const pbSource = upsellAddBtn.getAttribute("data-pb-source") || "pb-product";
        addItemsToCart(true, pbSource);
      });
    }

    if (upsellSkipBtn) {
      upsellSkipBtn.addEventListener("click", function () {
        addItemsToCart(false, null);
      });
    }

    if (upsellCloseBtn) {
      upsellCloseBtn.addEventListener("click", function () {
        addItemsToCart(false, null);
      });
    }
  });
});